<script setup lang="ts">
import missionLogo from '~/assets/icons/logo/mission.svg?url';
import image from '~/assets/images/about_mission_background.jpg';

const { t } = useI18n();
</script>

<template>
  <section class="aboutMission">
    <div class="aboutMission__content">
      <NuxtLink to="/" class="aboutMission__link">
        <img :src="missionLogo" :alt="t('mission_logo')" class="aboutMission__logo" />
      </NuxtLink>

      <p class="aboutMission__description">{{ t('content') }}</p>
    </div>

    <NuxtImg
      format="webp"
      :sizes="IMAGE_SIZES.adaptiveHalfScreen"
      :src="image"
      :alt="t('mission_alt')"
      class="aboutMission__image"
    />
  </section>
</template>

<i18n>
ru:
  mission_logo: Логотип миссии компании
  mission_alt: Описание миссии компании
  content: >
    Мы начинали с простого и очевидного — сделать косметику с рабочими формулами и удобной упаковкой. Мы думали, что этого достаточно.


    Но очень скоро стало ясно: в мире, где каждый день появляются десятки новых брендов, громкие кампании и «революционные» средства, просто делать качественную косметику недостаточно. Люди, с одной стороны, находятся в постоянном поиске, экспериментируют и тестируют новинки, а с другой — устают от бесконечного выбора, от одинаковых флаконов, от средств, которые разочаровывают или надоедают.


    Мы поняли: наша задача — создавать косметику, к которой хочется возвращаться. Сделать её не только вне времени, но и вне рекламных кампаний, вне грандиозных акций, вне громких обещаний.
en:
  mission_logo: Company mission logo
  mission_alt: Company mission description
  content: >
    When developing Don’t Touch My Skin products, we always strive for safety, comfort, and health. Usually, all three
    aspects are closely related to each other.


    We want you to feel comfortable in your body, with your skin, and cosmetics to be a pleasant and useful addition.
</i18n>

<style lang="scss">
.aboutMission {
  min-height: 100svh;
  display: flex;
  position: relative;

  @media (max-width: 768px) or ((orientation: portrait) and (max-width: 1060px)) {
    flex-direction: column;
    height: auto;
  }

  &__content {
    padding: 31px 20px 35px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 20px;
    background: #121212;
    width: 50%;

    @media (max-width: 768px) or ((orientation: portrait) and (max-width: 1060px)) {
      width: 100%;
    }

    @include mq('sm') {
      width: 100%;
      padding: 16px 16px 24px;
    }
  }

  &__link {
    display: block;
    width: fit-content;
  }

  &__logo {
    width: 343px;
    display: block;

    @include mq('sm') {
      width: 170px;
    }
  }

  &__description {
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0.2px;
    color: #ffffff;
    padding-right: 20px;
    margin: 0;
    white-space: pre-wrap;

    @include mq('sm') {
      font-size: 20px;
      line-height: 28px;
    }
  }

  &__image {
    width: 50%;
    height: 100svh;
    display: block;
    object-fit: cover;
    position: sticky;
    top: 0;
    bottom: 0;

    @media (max-width: 768px) or ((orientation: portrait) and (max-width: 1060px)) {
      width: 100%;
      height: auto;
      position: static;
    }
  }
}
</style>
